import Tabs from "@/v2-backoffice-client/components/tabs"
import { useInvoiceCollectionsQuery } from "@/v2-backoffice-client/license/collections/license.collections.query"
import { LICENSING_VIEW_COLLECTIONS } from "@/v2-backoffice-client/license/license.constants"

// The Licensing page's Collections tab trigger: how many invoices are past
// due or in nonpayment with money still outstanding. Owns its own read of
// the query — Apollo dedupes it against the board's — so the count stays
// live no matter which tab is open.
function LicenseCollectionTabTrigger() {
  const { data, previousData, loading } = useInvoiceCollectionsQuery()
  const openCount = (
    (data ?? previousData)?.getInvoiceCollections ?? []
  ).filter((invoice) => invoice.OutcomeCode == null).length

  return (
    <Tabs.Trigger
      value={LICENSING_VIEW_COLLECTIONS}
      iconSrc="file-invoice-dollar"
      isLoading={loading && !data && !previousData}
      count={openCount}
    >
      Collections
    </Tabs.Trigger>
  )
}

export default LicenseCollectionTabTrigger
